(function(scope){
  'use strict';
  function personalize(template,name){
    name=String(name||'').trim().slice(0,80);
    var text=template.replace(/,\s*\{name\}/gi,name?', '+name:'').replace(/\{name\},\s*/gi,name?name+', ':'').replace(/\{name\}/gi,name).replace(/\s+([,.!?])/g,'$1').replace(/\s{2,}/g,' ').trim();
    return name&&!/\{name\}/i.test(template)?name+', '+text:text;
  }
  function suggestion(library,locale,occasion,index,name,maxLength){
    locale=String(locale||'pt').toLowerCase().split('-')[0];
    var language=library[locale]||library.pt,choices=language[occasion]||language.other;
    for(var offset=0;offset<choices.length;offset++){var next=index+offset,text=personalize(choices[next%choices.length],name);if(text.length<=maxLength)return {text:text,next:next+1};}
    return null;
  }
  if(typeof module!=='undefined'&&module.exports){module.exports={personalize:personalize,suggestion:suggestion};return;}
  var libraryPromise;
  function initialize(root){
    root.querySelectorAll('[data-message-helper]').forEach(function(helper){
      if(helper.dataset.initialized)return;helper.dataset.initialized='true';
      var row=helper.closest('[data-message-scope],[data-cart-item]');
      if(!row)return;
      var textarea=row.querySelector('[data-message]');
      if(!textarea)return;
      var occasion=helper.querySelector('[data-message-occasion]'),recipient=helper.querySelector('[data-message-recipient]'),button=helper.querySelector('[data-message-suggest]'),status=helper.querySelector('[data-helper-status]'),preview=helper.querySelector('[data-suggestion]'),counts={},current='';
      function reset(){preview.hidden=true;current='';status.textContent='';button.textContent=helper.dataset.suggestLabel;occasion.removeAttribute('aria-invalid');}
      occasion.addEventListener('change',reset);recipient.addEventListener('input',reset);
      button.addEventListener('click',async function(){
        if(!occasion.value){status.textContent=helper.dataset.selectError;occasion.setAttribute('aria-invalid','true');occasion.focus();return;}
        button.disabled=true;status.textContent='';
        try{
          if(!libraryPromise)libraryPromise=fetch(helper.dataset.library,{credentials:'omit'}).then(function(response){if(!response.ok)throw new Error('Message library unavailable');return response.json();}).catch(function(error){libraryPromise=null;throw error;});
          var library=await libraryPromise;if(!helper.isConnected)return;
          var locale=helper.dataset.locale||document.documentElement.lang||'pt';
          var index=counts[occasion.value]||0,result=suggestion(library,locale,occasion.value,index,recipient.value,textarea.maxLength);
          if(!result)throw new Error('Message exceeds card length');
          counts[occasion.value]=result.next;current=result.text;helper.querySelector('[data-suggestion-text]').textContent=current;preview.hidden=false;button.textContent=helper.dataset.againLabel;
        }catch(error){status.textContent=helper.dataset.error;}
        finally{button.disabled=false;}
      });
      helper.querySelector('[data-use-message]').addEventListener('click',function(){if(!current)return;textarea.value=current;textarea.dispatchEvent(new Event('input',{bubbles:true}));preview.hidden=true;});
    });
  }
  scope.QRosesMessageHelper={initialize:initialize};initialize(document);
  document.addEventListener('shopify:section:load',function(event){initialize(event.target);});
}(typeof window!=='undefined'?window:globalThis));
